import React from 'react';

import { Box, Typography } from '@mui/material';

interface LegendItem {
  label: string;
  color: string;
}

interface Props {
  items: Array<LegendItem>;
}

export default function ChartExportLegend({ items }: Props) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, pt: 1, pb: 0.5 }}>
      {items.map((item) => (
        <Box key={item.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: item.color,
              flexShrink: 0,
            }}
          />
          <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{item.label}</Typography>
        </Box>
      ))}
    </Box>
  );
}
